<template>
    <div class="search-result">
        <!-- ============= 顶部背景图 ============= -->
        <div class="result-img">
          <img src="../../assets/images/toolsData/banner.png" style="width: 100%;display: block">
        </div>

        <!-- ============= 表格栏 ============= -->
        <div class="search-result-detaile">
            <div class="detaile-box">
                <div>
                    <div class="detaile-title">对外发布</div>
                </div>

                <div class="detaile-table">
                    <div class="table-title" v-html="title"></div>
                    <div class="product-info">
                        <div class="product-data" v-html="valu">
                            
                        </div>
                    </div>
                </div>
            </div>

        </div>
    </div>
</template>

<script>
    import api from '@/http/request'
    export default {
        data() {
            return {
                valu: '',
                title: '',
            }
        },
        mounted: function (){
            this.getNews();
        },
        methods: {
            getNews () { // 获取信息列表
                let _this = this;
                //获取GET的值
                this.$axios({
                    method:'get',
                    url:'/api/pre/json_go/file_html_show?id='+this.get_get_val('id'),
                }).then((response) =>{
                    this.title = response.data.tit;
                    this.valu = response.data.val;
                }).catch((error) =>
                    console.log(error)       //请求失败返回的数据
                )
            },
            get_get_val:function (get_name){
                // 获取参数type_id的值
                var reg = new RegExp("(^|&)" + get_name + "=([^&]*)(&|$)");
                var r = window.location.search.substr(1).match(reg);
                if (r != null){
                    return decodeURI(r[2]);
                }else{
                    return '';
                }
            },
        }
    }
</script>

<style>
  .search-result {min-width: 1300px;}
  .search-result .result-img img{width: 100%;min-width: 1300px}
  .search-result .el-divider--horizontal {height: 1px;margin: 0;background: rgba(74,144,226,1);width: 1200px;}
  .search-result .search-result-table { height: 360px;display: inline-block  }
  .search-result .search-result-detaile { background-color: rgba(246,246,246,1);width: 100% }
  .search-result .search-result-detaile .detaile-box{ width: 1300px;margin: 0 auto; padding: 50px 0 ; }
  .detaile-box .detaile-table {margin-top: 40px;}
  .table-content .el-table__row .is-center {border-right: 1px solid #EBEEF5;padding: 5px 0;}
  .table-content .has-gutter div {font-size: 16px;}
  .detaile-box .detaile-title {background:url('../../assets/images/product/kuang.png') no-repeat; background-size:100% 64px;height:64px;font-size:48px;padding: 0 40px 0 20px;color:#ffffff;display: inline-block;overflow: hidden;text-overflow: ellipsis;white-space: nowrap;max-width: 370px}
  .detaile-box .detaile-select {display: inline-block;float: right; line-height: 64px}
  .detaile-box .table-title { background-color:#eff5ff;width: 100%;line-height: 50px;text-align: center;font-size: 22px;font-weight: 500;border-bottom: 2px solid #4a90e2; }
  .detaile-box .product-info {width: 100%;background-color: #fff;}
  .detaile-box .product-info .product-data {margin:0 20px;color: #666666;line-height: 50px;overflow: hidden;text-overflow: ellipsis;white-space: nowrap;}
  .detaile-box .product-info .product-data  span {color: #000000;font-weight: 600;}
  .search-result .table-content { width:100%;}
</style>



// WEBPACK FOOTER //
// src/pages/tools/showvalue.vue